import { adminOpenJobRegionsTypes } from "../../ActionTypes/adminOpenJobRegionsTypes";
import { AdminOpenJobRegionsActions, AdminOpenJobRegionsState } from "../../types/type";


const initialState: AdminOpenJobRegionsState = {
  pending: false,
  regions: [],
  error: null,
};

export default (state = initialState, action: AdminOpenJobRegionsActions,) => {
  switch (action.type) {
    case adminOpenJobRegionsTypes.FETCH_ADMIN_OPEN_JOB_REGIONS_REQUEST:
      return {
        ...state,
        pending: false
      };
    case adminOpenJobRegionsTypes.FETCH_ADMIN_OPEN_JOB_REGIONS_SUCCESS:
      return {
        ...state,
        pending: true,
        regions: action.payload.regions,
        error: null
      };
    case adminOpenJobRegionsTypes.FETCH_ADMIN_OPEN_JOB_REGIONS_FAILURE:
      return {
        ...state,
        pending: false,
        regions: [],
        error: action.payload.error
      };
    default:
      return {
        ...state
      };
  }
};
